import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '内容分类',
      links: [
        { label: '情感连接', to: '/category/qinggan-lianjie' },
        { label: '性健康知识', to: '/category/xingjiankang-zhishi' },
        { label: '婚姻经营', to: '/category/hunyin-jingying' },
        { label: '两性沟通', to: '/category/liangxing-goutong' },
      ],
    },
    {
      title: '更多资源',
      links: [
        { label: '心理健康', to: '/category/xinli-jiankang' },
        { label: '亲子关系', to: '/category/qinzi-jiaoyu' },
        { label: '关于我们', to: '/about' },
      ],
    },
    {
      title: '法律声明',
      links: [
        { label: '隐私政策', to: '/about' },
        { label: '免责声明', to: '/about' },
        { label: '联系我们', to: '/about' },
      ],
    },
  ];

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-heart-pulse-line text-xl text-primary-400"></i>
                </span>
                <span className="text-lg font-heading font-semibold text-background-100">
                  性福生活
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                打造高质量亲密关系的完整指南。
                <br />
                专业、科学、温暖的亲密关系知识平台。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-background-100 mb-4">
                  {group.title}
                </h4>
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="text-sm text-background-400 hover:text-background-100 transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {currentYear} 性福生活. 保留所有权利。本站内容仅供参考，不构成医疗建议。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-500 hover:text-background-200 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-background-200 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-background-200 transition-colors" aria-label="邮箱">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}